<template>
  <div class="main-wrapper">
    <div class="individuals">
      <p class="no-individ">Физические лица</p>
      <p class="no-individ" v-if="information.length == 0">
        Данные об участниках-физических лицах отсутствуют
      </p>
      <div v-if="information.length > 0">
        <div
          class="main-individuals"
          v-for="info in information"
          :key="info.id"
        >
          <div
            class="show-title"
            @click="
              info.show = !info.show;
              clickShow = true;
            "
          >
            <p>
              <span :class="info.valid ? 'valid-field' : 'unvalid-field'"
                >➤</span
              >
              {{ info.LAST_NAME }} {{ info.FIRST_NAME }} {{ info.SUR_NAME }}
            </p>
            <div class="icons">
              <i class="fa fa-angle-up" v-if="info.show"></i>
              <i class="fa fa-angle-down" v-if="!info.show"></i>
            </div>
          </div>
          <div v-show="info.show">
            <table>
              <tr>
                <td class="left-column">
                  <p>Доля, %</p>
                </td>
                <td class="right-column">
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.PAY"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td class="left-column">
                  <p>Фамилия</p>
                </td>
                <td class="right-column">
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.LAST_NAME"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <p>Имя</p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.FIRST_NAME"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <p>Отчество</p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.SUR_NAME"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <p>ИНН (при наличии)</p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.INN"
                    v-mask="'############'"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('INN') != -1
                    "
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <p class="necessary-bold">Налоговый статус</p>
                </td>
                <td>
                  <dropdown
                    :options="taxesStatuses"
                    :selected="{ name: info.TAX_STATUS }"
                    placeholder="Выберите статус"
                    v-on:updateOption="onSelectTaxesStatus($event, info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('TAX_STATUS') != -1
                    "
                  ></dropdown>
                </td>
              </tr>
              <tr>
                <td>
                  <p>СНИЛС</p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.SNILS"
                    v-mask="'###-###-### ##'"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('SNILS') != -1
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    Тип документа, удостоверяющего личность
                  </p>
                </td>
                <td>
                  <dropdown
                    :options="docTypes"
                    :selected="{ name: info.DUL_DOCTYPE }"
                    v-on:updateOption="submit($event, info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('DUL_DOCTYPE') != -1
                    "
                  ></dropdown>
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.DUL_SERIAL != null && info.DUL_SERIAL.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Серия документа
                  </p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.DUL_SERIAL"
                    @input="
                      info.DUL_SERIAL != null &&
                      info.DUL_SERIAL != formatDocNumber(info.DUL_SERIAL)
                        ? (info.DUL_SERIAL = formatDocNumber(info.DUL_SERIAL))
                        : info.DUL_SERIAL
                    "
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('DUL_SERIAL') != -1
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.DUL_NUMBER != null && info.DUL_NUMBER.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Номер документа
                  </p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.DUL_NUMBER"
                    @input="
                      info.DUL_NUMBER != null &&
                      info.DUL_NUMBER != formatDocNumber(info.DUL_NUMBER)
                        ? (info.DUL_NUMBER = formatDocNumber(info.DUL_NUMBER))
                        : info.DUL_NUMBER
                    "
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('DUL_NUMBER') != -1
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        !info.unvalidDulDate &&
                        info.DUL_DATE != null &&
                        info.DUL_DATE.length == 10
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Дата выдачи документа
                  </p>
                </td>
                <td>
                  <input
                    type="text"
                    v-bind:class="
                      info.unvalidDulDate
                        ? 'necessary-unvalid'
                        : 'necessary-valid'
                    "
                    v-model="info.DUL_DATE"
                    v-mask="'##.##.####'"
                    placeholder="дд.мм.гггг"
                    :onchanged="dulDateChanged(info)"
                    @blur="checkDulDate(info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('DUL_DATE') != -1
                    "
                  />
                  <p class="necessary-message" v-if="info.unvalidDulDate">
                    Введите корректную дату выдачи документа
                  </p>
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        (info.DUL_CODE != null && info.DUL_CODE.length > 0) ||
                        info.hasCode
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Код подразделения
                  </p>
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.hasCode"
                      id="checkboxEnglishName"
                      @click="
                        info.DUL_CODE = '';
                        isUpdate = true;
                        info.issuerList = [];
                        info.disableIssue = false;
                      "
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('DUL_CODE') != -1
                      "
                    />
                    Код подразделения отсутствует
                  </label>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.DUL_CODE"
                    :disabled="
                      info.hasCode ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('DUL_CODE') != -1)
                    "
                    :onchanged="
                      info.DUL_CODE != null && info.DUL_CODE.length > 7
                        ? (info.DUL_CODE = info.DUL_CODE.substr(0, 7))
                        : info.DUL_CODE
                    "
                    v-mask="'###-###'"
                    @input="
                      isUpdate = true;
                      info.DUL_CODE.length == 7 &&
                      info.disableIssue != null &&
                      !info.disableIssue
                        ? getDulIssue(info)
                        : (info.disableIssue = false);
                      info.issuerList = [];
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.DUL_ISSUER != null &&
                        info.DUL_ISSUER.length > 0 &&
                        info.DUL_ISSUER != 'Подразделение не найдено'
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Наименование органа, выдавшего документ
                  </p>
                </td>
                <td>
                  <dropdown
                    v-if="info.issuerList != null && info.issuerList.length > 1"
                    :options="info.issuerList"
                    :selected="{ name: 'Выберите наименование' }"
                    v-on:updateOption="
                      info.DUL_ISSUER = $event.name;
                      isUpdate = true;
                      $forceUpdate();
                    "
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('DUL_ISSUER') != -1
                    "
                  ></dropdown>
                  <input
                    v-if="
                      info.issuerList == null || info.issuerList.length <= 1
                    "
                    class="input-line"
                    type="text"
                    v-model="info.DUL_ISSUER"
                    :onchanged="
                      info.DUL_ISSUER != null && info.DUL_ISSUER.length > 80
                        ? (info.DUL_ISSUER = info.DUL_ISSUER.substr(0, 80))
                        : info.DUL_ISSUER
                    "
                    :disabled="
                      (info.disableIssue != null &&
                        info.disableIssue &&
                        !info.hasCode) ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('DUL_ISSUER') != -1)
                    "
                    @focus="
                      info.DUL_ISSUER == 'Подразделение не найдено'
                        ? (info.DUL_ISSUER = '')
                        : info.DUL_ISSUER
                    "
                  />
                </td>
              </tr>

              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        !info.unvalidBirthDate &&
                        info.BIRTH_DATE != null &&
                        info.BIRTH_DATE.length == 10
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Дата рождения
                  </p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.BIRTH_DATE"
                    v-bind:class="
                      info.unvalidBirthDate
                        ? 'necessary-unvalid'
                        : 'necessary-valid'
                    "
                    v-mask="'##.##.####'"
                    placeholder="дд.мм.гггг"
                    :onchanged="birthDateChanged(info)"
                    @blur="checkBirthDate(info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('BIRTH_DATE') != -1
                    "
                  />
                  <p class="necessary-message" v-if="info.unvalidBirthDate">
                    Введите корректную дату рождения
                  </p>
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.BIRTH_PLACE != null && info.BIRTH_PLACE.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Место рождения
                  </p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.BIRTH_PLACE"
                    :onchanged="
                      info.BIRTH_PLACE != null && info.BIRTH_PLACE.length > 80
                        ? (info.BIRTH_PLACE = info.BIRTH_PLACE.substr(0, 80))
                        : info.BIRTH_PLACE
                    "
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('BIRTH_PLACE') != -1
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.CITIZENSHIP != null && info.CITIZENSHIP.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Гражданство (подданство) (указываются все страны, в которых
                    физическое лицо имеет гражданство)
                  </p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.CITIZENSHIP"
                    :onchanged="
                      info.CITIZENSHIP != null && info.CITIZENSHIP.length > 80
                        ? (info.CITIZENSHIP = info.CITIZENSHIP.substr(0, 80))
                        : info.CITIZENSHIP
                    "
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('CITIZENSHIP') != -1
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.REG_ADDRESS != null && info.REG_ADDRESS.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Адрес места жительства (регистрации)
                  </p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.REG_ADDRESS"
                    :onchanged="
                      info.REG_ADDRESS != null && info.REG_ADDRESS.length > 1000
                        ? (info.REG_ADDRESS = info.REG_ADDRESS.substr(0, 1000))
                        : info.REG_ADDRESS
                    "
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('REG_ADDRESS') != -1
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.FACT_ADDRESS != null &&
                        info.FACT_ADDRESS.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Адрес места пребывания
                  </p>
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.live_like_registration"
                      :checked="
                        info.live_like_registration
                          ? (info.FACT_ADDRESS = info.REG_ADDRESS)
                          : info.FACT_ADDRESS
                      "
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('FACT_ADDRESS') != -1
                      "
                    />Совпадает с местом жительства
                  </label>
                </td>
                <td>
                  <input
                    type="text"
                    class="input-line"
                    v-model="info.FACT_ADDRESS"
                    :disabled="
                      info.live_like_registration ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('FACT_ADDRESS') != -1)
                    "
                    :onchanged="
                      info.FACT_ADDRESS != null &&
                      info.FACT_ADDRESS.length > 1000
                        ? (info.FACT_ADDRESS = info.FACT_ADDRESS.substr(
                            0,
                            1000
                          ))
                        : info.FACT_ADDRESS
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.POST_ADDRESS != null &&
                        info.POST_ADDRESS.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Почтовый адрес
                  </p>
                  <div class="checkboxes">
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.mail_like_addresses[0]"
                        :checked="
                          !info.mail_like_addresses[1] &&
                          info.mail_like_addresses[0]
                            ? (info.POST_ADDRESS = info.REG_ADDRESS)
                            : info.POST_ADDRESS
                        "
                        @click="
                          info.mail_like_addresses = [
                            info.mail_like_addresses[0],
                            false,
                          ]
                        "
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('POST_ADDRESS') != -1
                        "
                      />Совпадает с местом жительства
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.mail_like_addresses[1]"
                        :checked="
                          info.mail_like_addresses[1] &&
                          !info.mail_like_addresses[0]
                            ? (info.POST_ADDRESS = info.FACT_ADDRESS)
                            : info.POST_ADDRESS
                        "
                        @click="
                          info.mail_like_addresses = [
                            false,
                            info.mail_like_addresses[1],
                          ]
                        "
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('POST_ADDRESS') != -1
                        "
                      />Совпадает с местом пребывания
                    </label>
                  </div>
                  <div class="checkboxes"></div>
                </td>
                <td>
                  <input
                    type="text"
                    class="input-line"
                    v-model="info.POST_ADDRESS"
                    :disabled="
                      info.mail_like_addresses[1] ||
                        info.mail_like_addresses[0] ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('POST_ADDRESS') != -1)
                    "
                    :onchanged="
                      info.POST_ADDRESS != null &&
                      info.POST_ADDRESS.length > 1000
                        ? (info.POST_ADDRESS = info.POST_ADDRESS.substr(
                            0,
                            1000
                          ))
                        : info.POST_ADDRESS
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p>Телефон</p>
                </td>
                <td>
                  <input
                    class="input-line"
                    type="text"
                    v-model="info.PHONE_NUMBER"
                    v-mask="'+7 (###) ###-##-##'"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('PHONE_NUMBER') != -1
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p>Адрес электронной почты</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-bind:class="
                      info.unvalidEmail
                        ? 'necessary-unvalid'
                        : 'necessary-valid'
                    "
                    v-model="info.E_MAIL"
                    placeholder="example@mail.com"
                    @blur="checkEmail(info)"
                    :onchanged="
                      info.E_MAIL != null && info.E_MAIL.length > 100
                        ? (info.E_MAIL = info.E_MAIL.substr(0, 100))
                        : info.E_MAIL
                    "
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('E_MAIL') != -1
                    "
                  />
                  <p class="necessary-message" v-if="info.unvalidEmail">
                    Введите корректный адрес электронной почты
                  </p>
                </td>
              </tr>
            </table>

            <p
              class="necessary-table-not"
              v-if="!(info.dataIsRight[0] || info.dataIsRight[1])"
            >
              Подтвердите корректность данных, заполненных автоматически.
            </p>
            <div class="data-is-right-checkboxes">
              <label>
                <input
                  type="checkbox"
                  v-model="info.dataIsRight[0]"
                  @click="info.dataIsRight = [info.dataIsRight[0], false]"
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('IS_DATA_VALID') != -1
                  "
                />Данные верны
              </label>
              <label>
                <input
                  type="checkbox"
                  v-model="info.dataIsRight[1]"
                  @click="
                    info.dataIsRight = [false, info.dataIsRight[1]];
                    info.INDIVIDUALS_FOUNDER_LIST_INVALID_DATA = '';
                  "
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('IS_DATA_VALID') != -1
                  "
                />Внести изменения
              </label>
            </div>
            <div v-show="info.dataIsRight[1]" class="invalid-data">
              <p class="necessary-bold">
                <span
                  :class="
                    (info.INDIVIDUALS_FOUNDER_LIST_INVALID_DATA != null &&
                      info.INDIVIDUALS_FOUNDER_LIST_INVALID_DATA.length > 0) ||
                    !info.dataIsRight[1]
                      ? 'valid-field'
                      : 'unvalid-field'
                  "
                  >➤</span
                >
                Укажите строку, в которой указаны неверные данные и укажите
                верные данные
              </p>
              <textarea
                class="invalid-data-textarea"
                v-model="info.INDIVIDUALS_FOUNDER_LIST_INVALID_DATA"
                :disabled="
                  info.DISABLED != null &&
                    info.DISABLED.indexOf(
                      'INDIVIDUALS_FOUNDER_LIST_INVALID_DATA'
                    ) != -1
                "
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="entities">
      <p class="no-individ">Юридические лица</p>
      <p class="no-individ" v-if="informationEntity.length == 0">
        Данные об участниках-юридических лицах-резидентах отсутствуют
      </p>
      <div v-if="informationEntity.length > 0">
        <div
          class="main-entities"
          v-for="info in informationEntity"
          :key="info.id"
        >
          <div class="show-title" @click="changeShow(info)">
            <p>
              <span :class="info.valid ? 'valid-field' : 'unvalid-field'"
                >➤</span
              >
              {{ info.ORG_FULL_NAME }}
            </p>
            <div class="icons">
              <i class="fa fa-angle-up" v-if="info.show"></i>
              <i class="fa fa-angle-down" v-if="!info.show"></i>
            </div>
          </div>
          <div v-show="info.show && info.FOREIGN_REG_NUMBER == null">
            <table>
              <tr>
                <td class="left-column">
                  <p>Доля, %</p>
                </td>
                <td class="right-column">
                  <input type="text" v-model="info.PAY" disabled />
                </td>
              </tr>
              <tr>
                <td class="left-column">
                  <p>Полное наименование организации</p>
                </td>
                <td class="right-column">
                  <input type="text" v-model="info.ORG_FULL_NAME" disabled />
                </td>
              </tr>
              <tr>
                <td class="left-column">
                  <p>Краткое наименование организации</p>
                </td>
                <td class="right-column">
                  <input type="text" v-model="info.ORG_BRIEF_NAME" disabled />
                </td>
              </tr>
              <tr>
                <td>
                  <p>ИНН</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.INN"
                    v-mask="'############'"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <p>ОГРН</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.OGRN"
                    v-mask="'#############'"
                    disabled
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">Налоговый статус</p>
                </td>
                <td>
                  <dropdown
                    :options="taxesStatuses"
                    :selected="{ name: info.TAX_STATUS }"
                    placeholder="Выберите статус"
                    v-on:updateOption="onSelectTaxesStatus($event, info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('TAX_STATUS') != -1
                    "
                  ></dropdown>
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p>Юридический адрес</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.UR_ADDRESS"
                    :onchanged="
                      info.UR_ADDRESS != null && info.UR_ADDRESS.length > 1000
                        ? (info.UR_ADDRESS = info.UR_ADDRESS.substr(0, 1000))
                        : info.UR_ADDRESS
                    "
                    disabled
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.FACT_ADDRESS != null &&
                        info.FACT_ADDRESS.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Фактический адрес
                  </p>
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.live_like_registration"
                      :checked="factAddress(info)"
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('FACT_ADDRESS') != -1
                      "
                    />Cовпадает с юридическим адресом
                  </label>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.FACT_ADDRESS"
                    :disabled="
                      info.live_like_registration ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('FACT_ADDRESS') != -1)
                    "
                    :onchanged="
                      info.FACT_ADDRESS != null &&
                      info.FACT_ADDRESS.length > 1000
                        ? (info.FACT_ADDRESS = info.FACT_ADDRESS.substr(
                            0,
                            1000
                          ))
                        : info.FACT_ADDRESS
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.BF_POSITION != null && info.BF_POSITION.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Адрес из устава
                  </p>
                  <div class="checkboxes">
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.ustav_like_addresses[0]"
                        :checked="bfAddress(info)"
                        @click="info.ustav_like_addresses[1] = false"
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('BF_POSITION') != -1
                        "
                      />Cовпадает с юридическим адресом
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.ustav_like_addresses[1]"
                        :checked="bfAddress()"
                        @click="info.ustav_like_addresses[0] = false"
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('BF_POSITION') != -1
                        "
                      />Cовпадает с фактичеcким адресом
                    </label>
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.BF_POSITION"
                    :disabled="
                      info.ustav_like_addresses[0] ||
                        info.ustav_like_addresses[1] ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('BF_POSITION') != -1)
                    "
                    :onchanged="
                      info.BF_POSITION != null && info.BF_POSITION.length > 1000
                        ? (info.BF_POSITION = info.BF_POSITION.substr(0, 1000))
                        : info.BF_POSITION
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.POST_ADDRESS != null &&
                        info.POST_ADDRESS.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Почтовый адрес
                  </p>
                  <div class="checkboxes">
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.mail_like_addresses[0]"
                        :checked="postAddress(info)"
                        @click="info.mail_like_addresses[1] = false"
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('POST_ADDRESS') != -1
                        "
                      />Cовпадает с юридическим адресом
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.mail_like_addresses[1]"
                        :checked="postAddress(info)"
                        @click="info.mail_like_addresses[0] = false"
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('POST_ADDRESS') != -1
                        "
                      />Cовпадает с фактичеcким адресом
                    </label>
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.POST_ADDRESS"
                    :disabled="
                      info.mail_like_addresses[0] ||
                        info.mail_like_addresses[1] ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('POST_ADDRESS') != -1)
                    "
                    :onchanged="
                      info.POST_ADDRESS != null &&
                      info.POST_ADDRESS.length > 1000
                        ? (info.POST_ADDRESS = info.POST_ADDRESS.substr(
                            0,
                            1000
                          ))
                        : info.POST_ADDRESS
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.PHONE_NUMBER == null ||
                        info.PHONE_NUMBER.length == 0 ||
                        info.PHONE_NUMBER.length > 8
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Телефон
                  </p>
                </td>
                <td>
                  <div class="phone">
                    +
                    <input
                      type="text"
                      v-model="info.PHONE_NUMBER"
                      :onchanged="fPhoneChanged(info)"
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('PHONE_NUMBER') != -1
                      "
                    />
                  </div>
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.E_MAIL == null ||
                        info.E_MAIL.length == 0 ||
                        (!info.unvalidEmail && info.E_MAIL.length > 8)
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Адрес электронной почты
                  </p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.E_MAIL"
                    placeholder="example@mail.com"
                    @blur="checkEmail(info)"
                    :onchanged="
                      info.E_MAIL != null && info.E_MAIL.length > 100
                        ? (info.E_MAIL = info.E_MAIL.substr(0, 100))
                        : info.E_MAIL
                    "
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('E_MAIL') != -1
                    "
                  />
                  <p class="necessary-message" v-if="info.unvalidEmail">
                    Введите корректный адрес электронной почты
                  </p>
                </td>
              </tr>
            </table>

            <div class="data-is-right-checkboxes">
              <label>
                <input
                  type="checkbox"
                  v-model="info.dataIsRight[0]"
                  @click="info.dataIsRight = [info.dataIsRight[0], false]"
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('IS_DATA_VALID') != -1
                  "
                />Данные верны
              </label>
              <label>
                <input
                  type="checkbox"
                  v-model="info.dataIsRight[1]"
                  @click="
                    info.dataIsRight = [false, info.dataIsRight[1]];
                    info.ENTITY_FOUNDER_LIST_INVALID_DATA = '';
                  "
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('IS_DATA_VALID') != -1
                  "
                />Внести изменения
              </label>
            </div>
            <div v-show="info.dataIsRight[1]" class="invalid-data">
              <p class="necessary-bold">
                <span
                  :class="
                    (info.ENTITY_FOUNDER_LIST_INVALID_DATA != null &&
                      info.ENTITY_FOUNDER_LIST_INVALID_DATA.length > 0) ||
                    !info.dataIsRight[1]
                      ? 'valid-field'
                      : 'unvalid-field'
                  "
                  >➤</span
                >
                Укажите строку, в которой указаны неверные данные и укажите
                верные данные
              </p>
              <textarea
                class="invalid-data-textarea"
                v-model="info.ENTITY_FOUNDER_LIST_INVALID_DATA"
                :disabled="
                  info.DISABLED != null &&
                    info.DISABLED.indexOf('ENTITY_FOUNDER_LIST_INVALID_DATA') !=
                      -1
                "
              ></textarea>
            </div>
          </div>
          <div v-show="info.show && info.FOREIGN_REG_NUMBER != null">
            <table>
              <tr>
                <td class="left-column">
                  <p>Доля, %</p>
                </td>
                <td class="right-column">
                  <input type="text" v-model="info.PAY" disabled />
                </td>
              </tr>
              <tr>
                <td class="left-column">
                  <p>Полное наименование организации</p>
                </td>
                <td class="right-column">
                  <input type="text" v-model="info.ORG_FULL_NAME" disabled />
                </td>
              </tr>
              <tr>
                <td class="left-column">
                  <p>Краткое наименование организации</p>
                </td>
                <td class="right-column">
                  <input type="text" v-model="info.ORG_BRIEF_NAME" disabled />
                </td>
              </tr>
              <tr>
                <td>
                  <p>Иностранный регистрационный номер</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.FOREIGN_REG_NUMBER"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <p>ОГРН</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.OGRN"
                    v-mask="'#############'"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <p>Страна</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.COUNTRY_NAME"
                    :onchanged="
                      info.COUNTRY_NAME != null &&
                      info.COUNTRY_NAME.length > 255
                        ? (info.COUNTRY_NAME = info.COUNTRY_NAME.substr(0, 255))
                        : info.COUNTRY_NAME
                    "
                    disabled
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">Налоговый статус</p>
                </td>
                <td>
                  <dropdown
                    :options="taxesStatuses"
                    :selected="{ name: info.TAX_STATUS }"
                    placeholder="Выберите статус"
                    v-on:updateOption="onSelectTaxesStatus($event, info)"
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('TAX_STATUS') != -1
                    "
                  ></dropdown>
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p>Юридический адрес</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.UR_ADDRESS"
                    :onchanged="
                      info.UR_ADDRESS != null && info.UR_ADDRESS.length > 1000
                        ? (info.UR_ADDRESS = info.UR_ADDRESS.substr(0, 1000))
                        : info.UR_ADDRESS
                    "
                    disabled
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.FACT_ADDRESS != null &&
                        info.FACT_ADDRESS.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Фактический адрес
                  </p>
                  <label>
                    <input
                      type="checkbox"
                      v-model="info.live_like_registration"
                      :checked="factAddress(info)"
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('FACT_ADDRESS') != -1
                      "
                    />Cовпадает с юридическим адресом
                  </label>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.FACT_ADDRESS"
                    :disabled="
                      info.live_like_registration ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('FACT_ADDRESS') != -1)
                    "
                    :onchanged="
                      info.FACT_ADDRESS != null &&
                      info.FACT_ADDRESS.length > 1000
                        ? (info.FACT_ADDRESS = info.FACT_ADDRESS.substr(
                            0,
                            1000
                          ))
                        : info.FACT_ADDRESS
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.BF_POSITION != null && info.BF_POSITION.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Адрес из устава
                  </p>
                  <div class="checkboxes">
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.ustav_like_addresses[0]"
                        :checked="bfAddress(info)"
                        @click="
                          info.ustav_like_addresses = [
                            info.ustav_like_addresses[0],
                            false,
                          ]
                        "
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('BF_POSITION') != -1
                        "
                      />Cовпадает с юридическим адресом
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.ustav_like_addresses[1]"
                        :checked="bfAddress(info)"
                        @click="
                          info.ustav_like_addresses = [
                            false,
                            info.ustav_like_addresses[1],
                          ]
                        "
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('BF_POSITION') != -1
                        "
                      />Cовпадает с фактичеcким адресом
                    </label>
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.BF_POSITION"
                    :disabled="
                      info.ustav_like_addresses[0] ||
                        info.ustav_like_addresses[1] ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('BF_POSITION') != -1)
                    "
                    :onchanged="
                      info.BF_POSITION != null && info.BF_POSITION.length > 1000
                        ? (info.BF_POSITION = info.BF_POSITION.substr(0, 1000))
                        : info.BF_POSITION
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.POST_ADDRESS != null &&
                        info.POST_ADDRESS.length > 0
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Почтовый адрес
                  </p>
                  <div class="checkboxes">
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.mail_like_addresses[0]"
                        :checked="postAddress(info)"
                        @click="
                          info.main_like_addresses = [
                            info.main_like_addresses[0],
                            false,
                          ]
                        "
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('POST_ADDRESS') != -1
                        "
                      />Cовпадает с юридическим адресом
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        v-model="info.mail_like_addresses[1]"
                        :checked="postAddress(info)"
                        @click="
                          info.main_like_addresses = [
                            false,
                            info.main_like_addresses[1],
                          ]
                        "
                        :disabled="
                          info.DISABLED != null &&
                            info.DISABLED.indexOf('POST_ADDRESS') != -1
                        "
                      />Cовпадает с фактичеcким адресом
                    </label>
                  </div>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.POST_ADDRESS"
                    :disabled="
                      info.mail_like_addresses[0] ||
                        info.mail_like_addresses[1] ||
                        (info.DISABLED != null &&
                          info.DISABLED.indexOf('POST_ADDRESS') != -1)
                    "
                    :onchanged="
                      info.POST_ADDRESS != null &&
                      info.POST_ADDRESS.length > 1000
                        ? (info.POST_ADDRESS = info.POST_ADDRESS.substr(
                            0,
                            1000
                          ))
                        : info.POST_ADDRESS
                    "
                  />
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.PHONE_NUMBER == null ||
                        info.PHONE_NUMBER.length == 0 ||
                        info.PHONE_NUMBER.length > 8
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Телефон
                  </p>
                </td>
                <td>
                  <div class="phone">
                    +
                    <input
                      type="text"
                      v-model="info.PHONE_NUMBER"
                      :onchanged="fPhoneChanged(info)"
                      :disabled="
                        info.DISABLED != null &&
                          info.DISABLED.indexOf('PHONE_NUMBER') != -1
                      "
                    />
                  </div>
                </td>
              </tr>
              <tr v-if="info.PAY >= 25">
                <td>
                  <p class="necessary-bold">
                    <span
                      :class="
                        info.E_MAIL == null ||
                        info.E_MAIL.length == 0 ||
                        (!info.unvalidEmail && info.E_MAIL.length > 8)
                          ? 'valid-field'
                          : 'unvalid-field'
                      "
                      >➤</span
                    >
                    Адрес электронной почты
                  </p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="info.E_MAIL"
                    placeholder="example@mail.com"
                    @blur="checkEmail(info)"
                    :onchanged="
                      info.E_MAIL != null && info.E_MAIL.length > 100
                        ? (info.E_MAIL = info.E_MAIL.substr(0, 100))
                        : info.E_MAIL
                    "
                    :disabled="
                      info.DISABLED != null &&
                        info.DISABLED.indexOf('E_MAIL') != -1
                    "
                  />
                  <p class="necessary-message" v-if="info.unvalidEmail">
                    Введите корректный адрес электронной почты
                  </p>
                </td>
              </tr>
            </table>

            <p
              class="necessary-table-not"
              v-if="!(info.dataIsRight[0] || info.dataIsRight[1])"
            >
              Подтвердите корректность данных, заполненных автоматически.
            </p>
            <div class="data-is-right-checkboxes">
              <label>
                <input
                  type="checkbox"
                  v-model="info.dataIsRight[0]"
                  @click="info.dataIsRight = [info.dataIsRight[0], false]"
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('IS_DATA_VALID') != -1
                  "
                />Данные верны
              </label>
              <label>
                <input
                  type="checkbox"
                  v-model="info.dataIsRight[1]"
                  @click="
                    info.dataIsRight = [false, info.dataIsRight[1]];
                    info.ENTITY_FOUNDER_LIST_INVALID_DATA = '';
                  "
                  :disabled="
                    info.DISABLED != null &&
                      info.DISABLED.indexOf('IS_DATA_VALID') != -1
                  "
                />Внести изменения
              </label>
            </div>
            <div v-show="info.dataIsRight[1]" class="invalid-data">
              <p class="necessary-bold">
                <span
                  :class="
                    (info.ENTITY_FOUNDER_LIST_INVALID_DATA != null &&
                      info.ENTITY_FOUNDER_LIST_INVALID_DATA.length > 0) ||
                    !info.dataIsRight[1]
                      ? 'valid-field'
                      : 'unvalid-field'
                  "
                  >➤</span
                >
                Укажите строку, в которой указаны неверные данные и укажите
                верные данные
              </p>
              <textarea
                class="invalid-data-textarea"
                v-model="info.ENTITY_FOUNDER_LIST_INVALID_DATA"
                :disabled="
                  info.DISABLED != null &&
                    info.DISABLED.indexOf('ENTITY_FOUNDER_LIST_INVALID_DATA') !=
                      -1
                "
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dropdown from "vue-dropdowns";
import mask from "./utils/my-mask.js";
import dateConventer from "./utils/date-converter.js";
import fieldFormatter from "./utils/field-formatter.js";
export default {
  name: "FoundersList",
  props: {
    pageInfo: {},
    pageName: String,
    url: String,
  },
  components: { dropdown },
  data: () => ({
    information: [],
    informationEntity: [],
    sendData: {},
    clickShow: false,
    taxesStatuses: [
      {
        name: "Резидент",
      },
      {
        name: "Нерезидент",
      },
    ],
    docTypes: [
      { name: "Паспорт гражданина РФ" },
      { name: "Загранпаспорт гражданина РФ" },
      { name: "Удостоверение личности военнослужащего РФ" },
      { name: "Паспорт иностранного гражданина" },
      { name: "Удостоверение беженца" },
      {
        name:
          "Свидетельство о предоставлении временного убежища на территории РФ",
      },
    ],
  }),
  methods: {
    formatDocNumber(field) {
      return fieldFormatter.formatDocNumber(field);
    },
    onSelectTaxesStatus(event, info) {
      info.TAX_STATUS = event.name;
    },
    checkEmail(data) {
      data.unvalidEmail = mask.emailCheck(data.E_MAIL);
    },
    changeShow(info) {
      info.show = !info.show;
      this.clickShow = true;
    },
    factAddress(item) {
      if (item != null && item.live_like_registration)
        item.FACT_ADDRESS = item.UR_ADDRESS;
    },
    bfAddress(item) {
      if (item != null && item.ustav_like_addresses[0])
        item.BF_POSITION = item.UR_ADDRESS;
      else if (item != null && item.ustav_like_addresses[1])
        item.BF_POSITION = item.FACT_ADDRESS;
    },
    postAddress(item) {
      if (item != null && item.mail_like_addresses[0])
        item.POST_ADDRESS = item.UR_ADDRESS;
      else if (item != null && item.mail_like_addresses[1])
        item.POST_ADDRESS = item.FACT_ADDRESS;
    },
    checkInformationEntity(item) {
      var msg = "";
      msg += "Для " + item.ORG_BRIEF_NAME + " заполните поля:<br>";
      if (item.PAY >= 25) {
        if (item.FACT_ADDRESS == null || item.FACT_ADDRESS.length == 0)
          msg += "• Фактический адрес<br>";
        if (item.BF_POSITION == null || item.BF_POSITION.length == 0)
          msg += "• Адрес из Устава<br>";
        if (item.POST_ADDRESS == null || item.POST_ADDRESS.length == 0)
          msg += "• Почтовый адрес<br>";
        if (item.unvalidEmail) msg += "• Адрес электронной почты<br>";
        if (
          item.PHONE_NUMBER != null &&
          item.PHONE_NUMBER.length > 0 &&
          item.PHONE_NUMBER.length <= 8
        )
          msg += "• Телефон<br>";
      }
      if (
        item.dataIsRight[1] &&
        (item.ENTITY_FOUNDER_LIST_INVALID_DATA == null ||
          item.ENTITY_FOUNDER_LIST_INVALID_DATA.length == 0)
      )
        msg +=
          "• Укажите строку, в которой указаны неверные данные и укажите верные данные<br>";
      if (!(item.dataIsRight[0] || item.dataIsRight[1]))
        msg +=
          "• Подтвердите корректность данных, заполненных автоматически<br>";
      if (msg.indexOf("•") != -1) return msg;
      else return "";
    },
    fPhoneChanged(info) {
      if (info.PHONE_NUMBER != null && info.PHONE_NUMBER.length > 13)
        info.PHONE_NUMBER = info.PHONE_NUMBER.substr(0, 13);
      if (info.PHONE_NUMBER != null)
        info.PHONE_NUMBER = info.PHONE_NUMBER.replace(/[^0-9]/g, "");
    },
    fillFoundersEntity(data) {
      if (data.TAX_STATUS == null || data.TAX_STATUS)
        data.TAX_STATUS = "Резидент";
      else data.TAX_STATUS = "Нерезидент";
      data.show = false;
      if (data.ENTITY_FOUNDER_LIST_INVALID_DATA == null)
        data.ENTITY_FOUNDER_LIST_INVALID_DATA = "";
      if (data.IS_DATA_VALID != null)
        data.dataIsRight = [data.IS_DATA_VALID, !data.IS_DATA_VALID];
      else data.dataIsRight = [false, false];
      if (data.FACT_ADDRESS == null) data.FACT_ADDRESS = "";
      if (data.BF_POSITION == null) data.BF_POSITION = "";
      if (data.POST_ADDRESS == null) data.POST_ADDRESS = "";
      if (data.E_MAIL == null) data.E_MAIL = "";
      if (data.PHONE_NUMBER == null) data.PHONE_NUMBER = "";
      data.live_like_registration = false;
      data.valid = false;
      data.mail_like_addresses = [false, false];
      data.ustav_like_addresses = [false, false];
      data.unvalidEmail = false;
      if (data.ORG_FULL_NAME == null) data.ORG_FULL_NAME = "";
    },
    async getDulIssue(info) {
      try {
        info.DUL_ISSUER = "";
        if (!info.disableIssue) {
          info.disableIssue = true;
          let response = await fetch(this.url + "get_passp_issuer_by_code", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify({
              DUL_CODE: info.DUL_CODE,
            }),
          });
          if (response.ok) {
            let data = await response.json();
            if (data.DUL_ISSUER != null) {
              switch (data.DUL_ISSUER.length) {
                case 0:
                  info.DUL_ISSUER = "Подразделение не найдено";
                  info.disableIssue = false;
                  break;
                case 1:
                  info.DUL_ISSUER = data.DUL_ISSUER[0];
                  info.disableIssue = true;
                  break;
                default:
                  info.issuerList = [];
                  info.disableIssue = true;
                  for (let i = 0; i < data.DUL_ISSUER.length; i++) {
                    info.issuerList.push({ name: data.DUL_ISSUER[i] });
                  }
                  break;
              }
            } else {
              info.DUL_ISSUER = "Подразделение не найдено";
              info.disableIssue = false;
            }
          } else throw new Error("Ошибка получения наименования подразделения");
        }
      } catch (e) {
        info.disableIssue = false;
        console.log(e);
      }
      this.$forceUpdate();
      this.validation();
    },
    fillFounder(data) {
      if (data.TAX_STATUS == null || data.TAX_STATUS)
        data.TAX_STATUS = "Резидент";
      else data.TAX_STATUS = "Нерезидент";
      data.show = false;
      if (data.IS_DATA_VALID != null)
        data.dataIsRight = [data.IS_DATA_VALID, !data.IS_DATA_VALID];
      else data.dataIsRight = [false, false];
      data.unvalidEmail = false;
      data.unvalidBirthDate = false;
      data.unvalidDulDate = false;
      data.issuerList = [];
      data.valid = false;
      if (data.DUL_DOCTYPE == null) data.DUL_DOCTYPE = "Паспорт гражданина РФ";
      if (data.INDIVIDUALS_FOUNDER_LIST_INVALID_DATA == null)
        data.INDIVIDUALS_FOUNDER_LIST_INVALID_DATA = "";
      if (data.PAY >= 25) {
        data.live_like_registration = false;
        data.mail_like_addresses = [false, false];
        if (data.DUL_CODE == null) data.DUL_CODE = "";
        data.hasCode =
          (data.DUL_CODE == null || data.DUL_CODE.length == 0) &&
          data.CITIZENSHIP != null;
        if (data.DUL_DATE == null) data.DUL_DATE = "";
        else data.DUL_DATE = dateConventer.fromServerConvert(data.DUL_DATE);
        if (data.BIRTH_DATE == null) data.BIRTH_DATE = "";
        else data.BIRTH_DATE = dateConventer.fromServerConvert(data.BIRTH_DATE);
        if (data.PHONE_NUMBER == null) data.PHONE_NUMBER = "";
        if (data.DUL_NUMBER == null) data.DUL_NUMBER = "";
        if (data.DUL_SERIAL == null) data.DUL_SERIAL = "";
        if (data.DUL_ISSUER == null) data.DUL_ISSUER = "";
        if (data.BIRTH_PLACE == null) data.BIRTH_PLACE = "";
        if (data.CITIZENSHIP == null) data.CITIZENSHIP = "";
        if (data.REG_ADDRESS == null) data.REG_ADDRESS = "";
        if (data.FACT_ADDRESS == null) data.FACT_ADDRESS = "";
        if (data.LAST_NAME == null) data.LAST_NAME = "";
        if (data.SUR_NAME == null) data.SUR_NAME = "";
        if (data.FIRST_NAME == null) data.FIRST_NAME = "";
        if (data.POST_ADDRESS == null) data.POST_ADDRESS = "";
        if (data.E_MAIL == null) data.E_MAIL = "";
        if (data.INN == null) data.INN = "";
        if (data.SNILS == null) data.SNILS = "";
        if (data.DUL_CODE == null) data.DUL_CODE = "";
      }
    },
    checkDate(date) {
      return mask.date(date);
    },
    birthDateChanged(info) {
      if (info.BIRTH_DATE != this.checkDate(info.BIRTH_DATE))
        info.BIRTH_DATE = this.checkDate(info.BIRTH_DATE);
      if (info.BIRTH_DATE != null && info.BIRTH_DATE.length == 10)
        this.checkBirthDate(info);
      else info.unvalidBirthDate = false;
    },
    dulDateChanged(info) {
      if (info.DUL_DATE != this.checkDate(info.DUL_DATE))
        info.DUL_DATE = this.checkDate(info.DUL_DATE);
      if (info.DUL_DATE != null && info.DUL_DATE.length == 10)
        this.checkDulDate(info);
      else info.unvalidDulDate = false;
    },
    checkDulDate(info) {
      let date = new Date();
      let dulDate = info.DUL_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(dulDate.split(".")[2]);
      let dul_months = parseInt(dulDate.split(".")[1]);
      let dul_days = parseInt(dulDate.split(".")[0]);
      if (dulDate.length == 10) {
        info.unvalidDulDate = !(
          dul_year < year ||
          (dul_year == year && dul_months < month) ||
          (dul_year == year && dul_months == month && dul_days < day)
        );
        if (info.unvalidDulDate)
          info.dulDateErrorMessage = "Введите корректную дату выдачи документа";
      } else if (dulDate.length == 0) {
        info.unvalidDulDate = false;
      } else {
        info.unvalidDulDate = true;
      }
    },
    checkBirthDate(info) {
      let date = new Date();
      let birthDate = info.BIRTH_DATE;

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      let dul_year = parseInt(birthDate.split(".")[2]);
      let dul_months = parseInt(birthDate.split(".")[1]);
      let dul_days = parseInt(birthDate.split(".")[0]);
      if (birthDate.length == 10) {
        info.unvalidBirthDate = !(
          dul_year < year ||
          (dul_year == year && dul_months < month) ||
          (dul_year == year && dul_months == month && dul_days < day)
        );
        if (info.unvalidBirthDate)
          info.birthDateErrorMessage =
            "Введите корректную дату выдачи документа";
      } else if (birthDate.length == 0) {
        info.unvalidBirthDate = false;
      } else {
        info.unvalidBirthDate = true;
      }
    },
    checkInformation(item) {
      var msg = "Для ";
      if (item.FIRST_NAME != null && item.FIRST_NAME.length > 0)
        msg += item.FIRST_NAME.substr(0, 1) + ". ";
      if (item.SUR_NAME != null && item.SUR_NAME.length > 0)
        msg += item.SUR_NAME.substr(0, 1) + ". ";
      msg += item.LAST_NAME + " заполните поля:<br>";
      if (item.PAY >= 25) {
        if (
          item.DUL_DATE == null ||
          item.DUL_DATE.length != 10 ||
          item.unvalidDulDate
        )
          msg += "• Дата выдачи документа<br>";
        if (
          item.BIRTH_DATE == null ||
          item.BIRTH_DATE.length != 10 ||
          item.unvalidBirthDate
        )
          msg += "• Дата рождения<br>";
        if (item.DUL_NUMBER == null || item.DUL_NUMBER.length == 0)
          msg += "• Номер документа<br>";
        if (item.DUL_SERIAL == null || item.DUL_SERIAL.length == 0)
          msg += "• Серия документа<br>";
        if (
          (item.DUL_CODE == null || item.DUL_CODE.length == 0) &&
          !item.hasCode
        )
          msg += "• Код подразделения<br>";
        if (
          item.DUL_ISSUER == null ||
          item.DUL_ISSUER.length == 0 ||
          item.DUL_ISSUER == "Подразделение не найдено"
        )
          msg += "• Наименование органа, выдавшего документ<br>";
        if (item.BIRTH_PLACE == null || item.BIRTH_PLACE.length == 0)
          msg += "• Место рождения<br>";
        if (item.CITIZENSHIP == null || item.CITIZENSHIP.length == 0)
          msg += "• Гражданство<br>";
        if (item.REG_ADDRESS == null || item.REG_ADDRESS.length == 0)
          msg += "• Адрес места жительства<br>";
        if (item.FACT_ADDRESS == null || item.FACT_ADDRESS.length == 0)
          msg += "• Адрес места пребывания<br>";
        if (item.POST_ADDRESS == null || item.POST_ADDRESS.length == 0)
          msg += "• Почтовый адрес<br>";
      }
      if (
        item.dataIsRight[1] &&
        (item.INDIVIDUALS_FOUNDER_LIST_INVALID_DATA == null ||
          item.INDIVIDUALS_FOUNDER_LIST_INVALID_DATA.length == 0)
      )
        msg +=
          "• Укажите строку, в которой указаны неверные данные и укажите верные данные<br>";
      if (!(item.dataIsRight[0] || item.dataIsRight[1]))
        msg +=
          "• Подтвердите корректность данных, заполненных автоматически<br>";
      if (msg.indexOf("•") != -1) return msg;
      else return "";
    },
    validation() {
      var msg = "";
      this.information.forEach((item) => {
        var tmp_msg = this.checkInformation(item);
        item.valid = tmp_msg.length == 0;
        msg += tmp_msg;
      });
      this.informationEntity.forEach((item) => {
        var tmp_msg = this.checkInformationEntity(item);
        item.valid = tmp_msg.length == 0;
        msg += tmp_msg;
      });
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        var info = JSON.parse(JSON.stringify(this.information));
        info.forEach((item) => {
          item.TAX_STATUS = item.TAX_STATUS == "Резидент";
          item.IS_DATA_VALID = item.dataIsRight[0];
          if (item.IS_DATA_VALID) {
            delete item.INDIVIDUALS_FOUNDER_LIST_INVALID_DATA;
          }
        });

        var infoEn = JSON.parse(JSON.stringify(this.informationEntity));
        infoEn.forEach((item) => {
          item.TAX_STATUS = item.TAX_STATUS == "Резидент";
          item.IS_DATA_VALID = item.dataIsRight[0];
        });

        this.sendData.EN_FOUNDERS = infoEn;
        this.sendData.IND_FOUNDERS = info;
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
  },
  async created() {
    try {
      this.sendData.INN = this.pageInfo.INN;

      this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
      this.sendData.ID = this.pageInfo.ID;
      if (this.pageInfo.IND_FOUNDERS != null) {
        for (let i = 0; i < this.pageInfo.IND_FOUNDERS.length; i++) {
          this.pageInfo.IND_FOUNDERS[i].id = i;
          this.fillFounder(this.pageInfo.IND_FOUNDERS[i]);
        }
        this.information = JSON.parse(
          JSON.stringify(this.pageInfo.IND_FOUNDERS)
        );
      }
      if (this.pageInfo.EN_FOUNDERS != null) {
        for (let i = 0; i < this.pageInfo.EN_FOUNDERS.length; i++) {
          this.pageInfo.EN_FOUNDERS[i].id = i;
          this.fillFoundersEntity(this.pageInfo.EN_FOUNDERS[i]);
        }
        this.informationEntity = JSON.parse(
          JSON.stringify(this.pageInfo.EN_FOUNDERS)
        );
      }
      this.validation();
    } catch (error) {
      console.log(error);
    }
  },
  updated() {
    this.validation();
    if (!this.clickShow) this.$emit("updated");
    this.clickShow = false;
  },
};
</script>

<style scoped>
.main-individuals {
  border: 1px solid #555555;
  margin-top: 10px;
}
.main-entities {
  border: 1px solid #555555;
  margin-top: 10px;
}
.main-wrapper {
  text-align: justify;
}
.left-column {
  width: 30%;
  display: flex;
  flex-direction: column;
}
.right-column {
  width: 70%;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
table {
  border-collapse: collapse;
  padding: 0px 5px;
  width: 100%;
}
.show-title {
  width: 100%;
  margin-top: 10px;
  cursor: default;
  text-align: center;
}
.icons {
  background-color: white;
  border: none;
  color: black;
  position: relative;
  font-size: 15px;
}
input[type="text"] {
  border: none;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin-left: 0px;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
td {
  padding: 5px 10px;
}
tr {
  border-top: 1px solid black;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
.necessary {
  color: red;
}
.data-is-right-checkboxes {
  text-align: center;
  padding: 5px 0px;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
.no-individ {
  text-align: center;
}
</style>
